import { Component } from '@angular/core';

@Component({
  selector: 'uoz-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'uoz-client-facing-front-end';
}
